
import { ProductListFilters } from '../components/ProductListFilters'

export const component = 'ProductListFilters' // Component to extend, required
export const exported = '@graphcommerce/magento-product' // Location where the component is exported, required

const ListPlugin = (props) => {
  // Prev in this case is ProductListItem, you should be able to see this if you log it.
  const { Prev, ...rest } = props
  return (
    <ProductListFilters
      {...rest}
    />
  )
}
export const Plugin = ListPlugin // An export with the name Plugin, required